(function () {
    'use strict';
    var m = angular.module('policy');
    m.controller('PolicyListController', ["$scope", function ($scope) {
        $scope.title = '#' + JSON.stringify({
            display: 'html',
            text: '<strong>Analytics</strong>'
        });
        $scope.refreshBtnOpt = {
            wrapClass: 'refresh-policy-list-page',
            onClickedMsg: 'do-refresh-policy-list-page',
            onFinishedMsg: 'done-refresh-policy-list-page'
        };
    }]);
}());